import { Capacitor } from "@capacitor/core";
import { Haptics, ImpactStyle } from "@capacitor/haptics";

export const triggerTabHaptic = async () => {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  try {
    const style =
      Capacitor.getPlatform() === "android"
        ? ImpactStyle.Medium
        : ImpactStyle.Light;
    await Haptics.impact({ style });
  } catch {
    // Haptics unavailable on some devices — ignore silently.
  }
};
